if (!customElements.get('countdown-popup')) {
  class CountdownPopup extends ModalDialog {
    constructor() {
      super();

      this.delay = Number(this.dataset.delay || 0) * 1000;
      this.frequency = this.dataset.frequency || 'session';
      this.cookieDays = Number(this.dataset.cookieDays || 7);
      this.cookieKey = this.dataset.cookieKey || 'bsr-countdown-popup';
    }

    connectedCallback() {
      super.connectedCallback();

      if (Shopify.designMode) {
        window.addEventListener('shopify:section:load', event => {
          if (!event.target.contains(this)) return;

          if (this.dataset.openInDesignMode === 'true') {
            this.show();
            return;
          }

          this.hide();
        });

        if (this.dataset.openInDesignMode === 'true') {
          setTimeout(() => this.show(), 50);
        }

        return;
      }

      if (this.shouldSkip()) return;

      setTimeout(() => {
        if (!this.shouldSkip()) this.show();
      }, this.delay);
    }

    hide() {
      super.hide();
      this.rememberDismissal();
    }

    rememberDismissal() {
      if (Shopify.designMode || this.frequency === 'every') return;

      if (this.frequency === 'session') {
        try {
          window.sessionStorage.setItem(this.cookieKey, 'true');
        } catch (error) {
          setCookie(this.cookieKey, 'true', false, true);
        }
        return;
      }

      setCookie(this.cookieKey, 'true', this.cookieDays, true);
    }

    shouldSkip() {
      if (this.frequency === 'every') return false;

      if (this.frequency === 'session') {
        try {
          return window.sessionStorage.getItem(this.cookieKey) === 'true';
        } catch (error) {
          return getCookie(this.cookieKey) !== null;
        }
      }

      return getCookie(this.cookieKey) !== null;
    }
  }

  customElements.define('countdown-popup', CountdownPopup);
}
